import { IDataTh, ThCoreIndex } from "src/Pages/components";

export const TheadPayments = () => {
  const dataTh: IDataTh[] = [
    {
      title: "Data vencimento",
      width: "100px",
      align: "left",
    },
    {
      title: "Mensalidade",
      align: "right",
      width: "100px",
    },
    {
      title: "Método de pagamento",
      align: "center",
      width: "150px",
    },
    {
      title: "Data pagamento",
      align: "right",
      width: "120px",
    },
    {
      title: "Status do pagamento",
      align: "center",
      width: "35%",
    },
  ];

  return <ThCoreIndex key={1} dataTh={dataTh} />;
};
